<template>
	<div id="customize">
		<h4>Customize Homepage</h4>
		<br>
		<div v-for="user of users.filter(thisUser)" v-bind:key="user['.key']">
			<b-row>
				<b-col cols="2">
					Title
				</b-col>
				<b-col cols="7">
					<b-input v-model="user.title"></b-input>
				</b-col>
			</b-row>
			<br>
			<b-row>
				<b-col cols="2">
					Title Text
				</b-col>
				<b-col cols="7">
					<b-input v-model="user.titleText"></b-input>
				</b-col>
			</b-row>
			<br>
			<b-row>
				<b-col cols="2">
					Note from Admin 
				</b-col>
				<b-col cols="7">
					<b-textarea v-model="user.note"></b-textarea>
				</b-col>
			</b-row>
			<br>
			<b-row>
				<b-col cols="2">
					Other Info
				</b-col>
				<b-col cols="7">
					<b-textarea v-model="user.other"></b-textarea>
				</b-col>
			</b-row>
			<br>
			<b-row>
				<b-col cols="2">
					Background Image 
				</b-col>
				<b-col cols="7">
					<b-form-file accept=".jpg, .png, .gif" @change="onChange"></b-form-file>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="9"><hr></b-col>
			</b-row>
			<b-row>
				<b-col cols="2" class="text-center">
					<b-button variant="primary" style="width:100%" @click="save(user)">Save</b-button> 
				</b-col>
			</b-row>
		</div>
		<div id="snackbar">{{toastMessage}}</div>
	</div>
</template>

<style>
#customize {
	padding: 50px 50px 50px 50px;
}

#snackbar {
	visibility: hidden; /* Hidden by default. Visible on click */
	min-width: 250px; /* Set a default minimum width */
	margin-left: -125px; /* Divide value of min-width by 2 */
	background-color: #333; /* Black background color */
	color: #fff; /* White text color */
	text-align: center; /* Centered text */
	border-radius: 2px; /* Rounded borders */
	padding: 16px; /* Padding */
	position: fixed; /* Sit on top of the screen */
	z-index: 1; /* Add a z-index if needed */
	left: 45%; /* Center the snackbar */
	bottom: 30px; /* 30px from the bottom */
}


#snackbar.show {
	visibility: visible; 
	-webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
	animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

/* Animations to fade the snackbar in and out */
@-webkit-keyframes fadein {
	from {bottom: 0; opacity: 0;}
	to {bottom: 30px; opacity: 1;}
}

@keyframes fadein {
	from {bottom: 0; opacity: 0;}
	to {bottom: 30px; opacity: 1;}
}

@-webkit-keyframes fadeout {
	from {bottom: 30px; opacity: 1;}
	to {bottom: 0; opacity: 0;}
}

@keyframes fadeout {
	from {bottom: 30px; opacity: 1;}
	to {bottom: 0; opacity: 0;}
}
</style>

<script>
import { userRef } from '../firebase'
import { firebaseStorage } from '../firebase';
export default {
	name: 'customize',
	data () {
		return {
			users: [],
			image: null,
			toastMessage: ''
		}
	},
	firebase: {
		users: userRef
	},
	methods: {
		save(user){
			var imageName = '';
			userRef.child(user['.key']).update({title: user.title?user.title:'', titleText: user.titleText?user.titleText:'', note: user.note?user.note:'', other: user.other?user.other:'', fileName: ''});
			
			if(this.image!=null){
				imageName = this.image.name + new Date();
				if(!(user.fileName === '' || user.fileName == null)){
					firebaseStorage.child(user.fileName).delete()		
				}
				var task = firebaseStorage.child(imageName).put(this.image);   
				task.on(
					'state_changed',
					null,
					null,
					() => {
						console.log('upload complete!');
						firebaseStorage.child(imageName).getDownloadURL().then((url) => { 
							userRef.child(user['.key']).update({title:  user.title?user.title:'', titleText: user.titleText?user.titleText:'', note: user.note?user.note:'', other: user.other?user.other:'', fileName: imageName, url:url});
						});       
					});
			}
			this.showSnackBar('Homepage updated');
		},
		getUser(){
			return this.$parent.activeUser?this.$parent.activeUser.name:'';
		},
		thisUser(user){
			return user.user==this.getUser()?user:null
		},
		onChange(event){
			this.image = event.target.files[0]
		},
		showSnackBar(message){
			this.toastMessage = message;
			var x = document.getElementById("snackbar");
			x.className = "show";
			setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
		},
	}
}
</script>